import React from "react";
import Hero from "../components/Hero";
import About from "../components/About";
import Why from "../components/Why";
import Solutions from "../components/Solutions";
import How from "../components/How";
import Benefits from "../components/Benefits";
import Choose from "../components/Choose";
import Industries from "../components/Industries";
import Story from "../components/Story";
import Decisions from "../components/Decisions";
import Partner from "../components/Partner";
import Demo from "../components/Demo";
import Callback from "../components/Callback";
import Newsletter from "../components/Newsletter";
import Testimonials from "../components/Testimonials";
import Faqs from "../components/Faqs";
import Cta from "../components/Cta";

const LandingPage = () => {
  return (
    <>
      <Hero />
      <About />
      <Why />
      <Solutions />
      <How />
      <Benefits />
      <Choose />
      <Industries />
      <Story />
      <Decisions />
      <Partner />
      <Demo />
      <Callback />
      <Newsletter />
      <Testimonials />
      <Faqs />
      <Cta />
    </>
  );
};

export default LandingPage;
